// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__vdqK5","header":"styles_header__1gG3k","title":"styles_title__9eOs7","tableHeader":"styles_tableHeader__3jm0U"};